/* RESPONSIBLE TEAM: team-frontend-tech */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file: 🚀 */
/* eslint-disable ember/no-actions-hash */
/* eslint-disable ember/no-classic-classes */
/* eslint-disable ember/no-classic-components */
/* eslint-disable ember/no-jquery */
/* eslint-disable @intercom/intercom/require-empty-tagname */
import $ from 'jquery';
import Component from '@ember/component';
import DomMixin from 'ember-lifeline/mixins/dom';
export default Component.extend(DomMixin, {
  didInsertElement() {
    this._super(...arguments);
    this.focusInput();
    this.setupEvents();
  },
  setupEvents() {
    this.addEventListener(this.element, 'keyup', e => {
      if (e.keyCode === 27) {
        e.preventDefault();
        e.stopPropagation();
        this.send('completeEditingFilterBlock');
      }
    });
  },
  focusInput() {
    let textlikeFields = $('input[type=text],input[type=number],input[type=email],input[type=tel],input[type=url]', this.element);
    if (textlikeFields.length === 0) {
      $('input[type=radio]:checked', this.element).eq(0).focus();
    } else {
      textlikeFields.eq(0).focus();
    }
  },
  actions: {
    completeEditingFilterBlock() {
      this.hideDropdownOverlay();
    }
  }
});